<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-card-title>
        Override Counts
        <v-spacer />
        <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-subtitle class="pt-1">{{ question.display_text || question.text }}</v-card-subtitle>
      <v-card-text>
        <v-simple-table>
          <thead>
            <tr>
              <th>Option</th>
              <th width="150">Count</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in editableOptions" :key="index">
              <td>{{ item.optionText }}</td>
              <td>
                <v-text-field
                  v-model.number="item.count"
                  type="number"
                  dense
                  hide-details
                  outlined
                  min="0"
                />
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="error" @click="clearAll">Clear All</v-btn>
        <v-spacer />
        <v-btn text @click="close">Cancel</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { DataService } from '../../services/BuyerDataService'
const dataService = new DataService()

export default {
  name: 'OverrideCountsModal',
  data() {
    return {
      dialog: false,
      saving: false,
      question: {},
      projectId: null,
      editableOptions: []
    }
  },
  methods: {
    open(projectId, question) {
      this.projectId = projectId
      this.question = question
      this.editableOptions = (question.options || []).map(o => {
        let existing = (question.overrideCounts || []).find(oc => oc.optionText === (o.display_text || o.text))
        return {
          optionText: o.display_text || o.text,
          count: existing ? existing.count : null
        }
      })
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    clearAll() {
      this.editableOptions.forEach(o => { o.count = null })
    },
    async save() {
      this.saving = true
      try {
        let overrideCounts = this.editableOptions
          .filter(o => o.count !== null && o.count !== '' && o.count >= 0)
          .map(o => ({ optionText: o.optionText, count: Number(o.count) }))

        await dataService.updateOverrideCounts({
          projectId: this.projectId,
          questionId: this.question._id,
          overrideCounts
        })

        this.question.overrideCounts = overrideCounts
        this.$emit('saved')
        this.close()
      } catch (e) {
        alert('Error saving override counts: ' + (e.response ? e.response.data.message : e.message))
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
